"use strict";

/*
  Prepares and handles the video uploader element.
*/

const $ = require("jquery");
const axios = require("axios");
const formStatus = require("./../booking-form-status/booking-form-status");

// returns the upload url for an image.
function getUploadUrl(identifier) {
  const route = $(".js-video-upload-wrapper").data("url");
  const url = `${route}?identifier=${identifier}&type=video`;
  return url;
}

// returns the update url for an image.
function getUpdateUrl(id) {
  const route = $(".js-video-upload-wrapper").data("url");
  const url = `${route}/${id}`;
  return url;
}

// returns the delete url for an image.
// eslint-disable-next-line no-unused-vars
function getDeleteUrl(id) {
  const route = $(".js-video-upload-wrapper").data("url");
  const url = `${route}/${id}`;
  return url;
}

// Add or remove the link element from the audio upload.
function updateTheVideoLink(videoUploader, url, description = "") {
  if (url) {
    let link = "";
    link =
      '<a href="' +
      url +
      '" target="_blank" class="link--green video-uploader__link ">';
    link += "<span>";
    link += description;
    link += "</span>";
    link += "</a>";

    $(videoUploader)
      .find(".js-video-uploader-label")
      .html(link);
  } else {
    $(".js-video-uploader-label").html("");
  }
}

// callback after successful uplaod
function onUploadSuccess(videoUploader, data) {
  $(".js-video-upload-submit").removeClass("button--orange");
  const url = data.mediaItem.url;
  const description = data.mediaItem.description
    ? data.mediaItem.description
    : data.mediaItem.value;

  updateTheVideoLink(videoUploader, url, description);
  $(videoUploader)
    .find(".js-video-uploader-description")
    .val(description);
  $(videoUploader)
    .find("form")
    .attr("data-id", data.mediaItem.id);

  $(videoUploader)
    .find("input")
    .attr("value", data.mediaItem.url);

  $(videoUploader).addClass("video-uploader--has-file");
  $(videoUploader).removeClass("video-uploader--has-changed");
  formStatus.showSuccess("js-video-upload-section-form-status", data.success);
  window.location.reload();
}

// callback after failed upload
function onUploadError(videoUploader, err) {
  formStatus.showError("js-video-upload-section-form-status", err);
  $(videoUploader).removeClass("audio-uploader--loading");
  updateTheVideoLink(videoUploader, null);
}

// callback after successsful delete.
function onDeleteSuccess(videoUploader, data) {
  $(".js-video-upload-submit").removeClass("button--orange");
  $(videoUploader).removeClass("video-uploader--has-file");
  $(videoUploader)
    .find("form")
    .attr("data-id", "null");
  $(videoUploader)
    .find(".js-video-uploader-description")
    .val("");
  $(videoUploader)
    .find(".js-video-uploader-link")
    .html("");
  updateTheVideoLink(videoUploader, null);

  formStatus.showSuccess("js-video-upload-section-form-status", data.success);
}

function onDeleteError(videoUploader, err) {
  formStatus.showError("js-video-upload-section-form-status", err);
}

// make the actual request.s
function makeRequest(url, formData, method, videoUploader) {
  $(".js-video-loader").addClass("loader--active");
  const headers = {
    "Content-Type": "multipart/form-data",
    Accept: "application/json",
    cache: false
  };
  formData.append("_method", method);

  axios
    .post(url, formData, headers)
    .then(function(result) {
      $(".js-video-loader").removeClass("loader--active");
      if (method == "DELETE") {
        onDeleteSuccess(videoUploader, result.data);
      } else {
        onUploadSuccess(videoUploader, result.data);
      }

      $(videoUploader)
        .find("input[type=file]")
        .val("");
      $(videoUploader).removeClass("video-uploader--loading");
      $(videoUploader).removeClass("video-uploader--has-changed");
    })
    .catch(function(err) {
      $(".js-video-loader").removeClass("loader--active");
      $(videoUploader).removeClass("video-uploader--loading");

      let errorMessage;
      try {
        for (let attribute in err.response.data.errors) {
          let errorsForAttribute = err.response.data.errors[attribute];
          errorMessage = errorsForAttribute[0];
        }
      } catch (e) {
        errorMessage = err.response.data.message;
      }

      if (method == "DELETE") {
        onDeleteError(videoUploader, errorMessage);
      } else {
        onUploadError(videoUploader, errorMessage);
      }
    });
}

// collect and trigger file upload.
function uploadVideoFiles() {
  formStatus.clearStatus("js-video-upload-section-form-status");
  $(".video-uploader--has-changed").each(function(_, videoUploader) {
    uploadSingleVideo(videoUploader);
  });
}

/**
 *
 * Uploads a single video
 *
 * @param {*} videoUploader
 */
function uploadSingleVideo(videoUploader) {
  $(videoUploader).addClass("video-uploader--loading");
  const form = $(videoUploader)
    .find("form")
    .get(0);
  const formData = new FormData(form);

  const id = $(form).attr("data-id");
  const identifier = $(form).attr("data-identifier");
  const url = id == "null" ? getUploadUrl(identifier) : getUpdateUrl(id);
  const method = id == "null" ? "POST" : "PUT";

  const value = formData.get("value");
  // Handle the video link input.
  if (typeof value === "string") {
    // formData.append("description", "");
    if (value === "") {
      deleteItem(videoUploader, false);
      return;
    }
  } else {
    formData.append("description", formData.get("value").name);
  }

  makeRequest(url, formData, method, videoUploader);
}

// delete the video file
function deleteItem(videoUploader, showConfirmWindow = true) {
  if (!showConfirmWindow) {
    formStatus.clearStatus("js-video-upload-section-form-status");
    $(videoUploader).addClass("video-uploader--loading");
    const form = $(videoUploader).find("form");
    const formData = new FormData(form.get(0));
    const method = "DELETE";
    const id = $(form).attr("data-id");
    formData.append("_method", "DELETE");
    const url = getDeleteUrl(id);
    makeRequest(url, formData, method, videoUploader);
  } else {
    $.confirm({
      title: "Löschen bestätigen",
      content: "Willst du die Medien Datei wirklich löschen?",
      draggable: false,
      backgroundDismiss: true,
      buttons: {
        cancel: {
          text: "Abbrechen",
          action: function() {}
        },
        confirm: {
          text: "Löschen",
          btnClass: "button button--orange",
          action: function() {
            formStatus.clearStatus("js-video-upload-section-form-status");
            $(videoUploader).addClass("video-uploader--loading");
            const form = $(videoUploader).find("form");
            const formData = new FormData(form.get(0));
            const method = "DELETE";
            const id = $(form).attr("data-id");
            formData.append("_method", "DELETE");
            const url = getDeleteUrl(id);
            makeRequest(url, formData, method, videoUploader);
          }
        }
      }
    });
  }
}

// callback after file was loaded at the user browser.
function videoLoaded(videoUploader) {
  $(videoUploader).addClass("video-uploader--has-changed");

  const file = $(videoUploader)
    .find("input[type=file]")
    .get(0).files[0];

  const name_label = "File selected: " + file.name;

  $(videoUploader)
    .find(".js-video-uploader-label")
    .html("<span class='video-uploader__link'> " + name_label + " </span>");
}

// callback after video link is updated.
function videoLinkChanged(videoUploader) {
  $(videoUploader).addClass("video-uploader--has-changed");
  $(".js-video-upload-submit").addClass("button--orange");
  $(".js-video-upload-submit").attr("disabled", false);
  $(".js-profile-media-submit").addClass("button--orange");
}

// initializes the module and bootstraps the UI.
function onLoad(consentControl) {
  $(".js-video-uploader").each(function(i, videoUploader) {
    $(videoUploader)
      .find("input[type=file]")
      .on("change", function() {
        if ($(videoUploader).hasClass("video-uploader--has-changed")) {
          videoLoaded(videoUploader);
        }
      });

    $(videoUploader).find(".js-video-upload-submit");

    $(".js-video-uploader")
      .find("input[type=text]")
      .on("change", function() {
        $(videoUploader).addClass("video-uploader--has-changed");
      });

    $(videoUploader)
      .find("input[type=text]")
      .on("input paste keydown", function() {
        videoLinkChanged(videoUploader);
      });

    $(videoUploader)
      .find(".js-video-uploader-delete")
      .on("click", function() {
        deleteItem(videoUploader);
      });

    $(videoUploader)
      .find("form")
      .on("keyup keypress", function(e) {
        var keyCode = e.keyCode || e.which;
        if (keyCode === 13) {
          e.preventDefault();
          return false;
        }
      });
  });

  $(".js-video-upload-submit").on("click", function() {
    consentControl(function() {
      uploadVideoFiles();
    });

    //$(".box").load(location.href+" .box>*","");
  });
}

if (process.env.NODE_ENV === "test") {
  module.exports = {
    onLoad,
    videoLoaded
  };
} else {
  module.exports = {
    onLoad,
    uploadVideoFiles
  };
}



// WEBPACK FOOTER //
// ./resources/js/libraries/booking-video-uploader/booking-video-uploader.js